import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';

class InsightCellRendered extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hanldeClick = this.hanldeClick.bind(this);
  }

  hanldeClick(opportunities) {
    this.props.onSelect(opportunities);
  }

  renderStat(value, opportunities, cls) {
    if (value === null) {
      return (<span className="text-muted">N/A</span>);
    }
    const comp = (<span className={cls}><MoneyDisplay value={value} abbreviated /></span>);
    if (opportunities && opportunities.length) {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hanldeClick(opportunities);
          }}
        >
          {comp}
        </a>
      );
    }
    return comp;
  }

  renderPercentage(value, percentage = null, opportunities = null, cls = null) {
    if (value === null) {
      return null;
    }
    const comp = <span className={`label ${cls}`}><NumberDisplay value={(percentage * 100)} suffix="%" precision={1} /></span>;
    if (opportunities && opportunities.length) {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hanldeClick(opportunities);
          }}
        >
          {comp}
        </a>
      );
    }
    return comp;
  }

  renderProjectedInsights() {
    const { stats } = this.props;
    let firstLineComp = null;
    let secondLineComp = null;
    let joinComp = null;

    if (stats.salesGoalAttainment >= 0) {
      firstLineComp = (
        <div className="text-success">
          <strong>should exceed goal by <MoneyDisplay value={stats.salesGoalAttainment} abbreviated /></strong>
        </div>
      );
      secondLineComp = (
        <div className="text-success">
          <strong><NumberDisplay withPlus suffix="%" value={(stats.winRateGap * 100)} precision={1} /> point win rate buffer to hit sales goal</strong>
        </div>
      );
    } else {
      firstLineComp = (
        <div className="text-danger">
          <strong>need <MoneyDisplay value={stats.pipelineNeeded} abbreviated /> new pipeline</strong>
        </div>
      );
      secondLineComp = (
        <div className="text-danger">
          <strong>
            <NumberDisplay withPlus suffix="%" value={(Math.abs(stats.winRateGap) * 100)} precision={1} />
            {' '}
            win rate increase will yield
            {' '}
            <MoneyDisplay value={Math.abs(stats.salesGoalAttainment)} abbreviated />
          </strong>
        </div>
      );
    }
    if (firstLineComp !== null && secondLineComp !== null) {
      joinComp = (<div>and/or</div>);
    }
    return (
      <div className="text-center">
        {firstLineComp}
        {joinComp}
        {secondLineComp}
      </div>
    );
  }

  render() {
    const { 
      stats, data, isProjectedSales, rowType,
    } = this.props;
    if (data.skip_conversion) {
      return (<span className="text-muted text-center">&nbsp;</span>);
    }
    if (rowType !== 'total') {
      return (<div>&nbsp;</div>);
    }
    if (isProjectedSales) {
      return this.renderProjectedInsights();
    }

    let s = null;
    if (stats && stats.stages && stats.stages[data.value]) {
      s = stats.stages[data.value];
    }

    let total = null;
    let thisAmount = null;
    let thisPercentage = null;
    let nextAmount = null;
    let nextPercentage = null;
    let opportunities = [];
    let thisOpportunities = [];
    let nextOpportunities = [];

    if (s) {
      total = s.projectedAmount;
      thisAmount = s.thisProjectedAmount;
      nextAmount = s.nextProjectedAmount;
      thisPercentage = s.thisProjectedPercentage;
      nextPercentage = s.nextProjectedPercentage;
      ({ opportunities, thisOpportunities, nextOpportunities } = s);
    }

    const totalLabel = (<span>Total&nbsp;projected</span>);
    const thisLabel = (<span>This&nbsp;period</span>);
    const nextLabel = (<span>Next&nbsp;period</span>);

    return (
      <table className="table table-condensed">
        <tbody>
          <tr>
            <th width="90">{totalLabel}</th>
            <td className="text-right" colSpan="2">
              {this.renderStat(total, opportunities)}
            </td>
          </tr>
          <tr>
            <th>{thisLabel}</th>
            <td className="text-right">
              {this.renderStat(thisAmount, thisOpportunities, 'text-success')}
            </td>
            <td className="text-right" width="50">
              {this.renderPercentage(thisAmount, thisPercentage, thisOpportunities, 'label-success')}
            </td>
          </tr>
          <tr>
            <th>{nextLabel}</th>
            <td className="text-right">
              {this.renderStat(nextAmount, nextOpportunities, 'text-danger')}
            </td>
            <td className="text-right" width="50">
              {this.renderPercentage(nextAmount, nextPercentage, nextOpportunities, 'label-danger')}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

InsightCellRendered.propTypes = {
  stats: PropTypes.shape({
  }),
  data: PropTypes.shape({
    value: PropTypes.string,
    skip_conversion: PropTypes.bool,
  }).isRequired,
  isProjectedSales: PropTypes.bool,
  rowType: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};
InsightCellRendered.defaultProps = {
  stats: null,
  isProjectedSales: false,
  onSelect: () => {},
};
export default InsightCellRendered;
